import PriceHistory from "./valueObjects/priceHistory";
import UnitStatus from "./valueObjects/unitStatus";

interface Endereco {
  rua: string;
  numero: string;
  bairro: string;
  cidade: string;
}

export default class Unit {
  constructor(
    public id = "",
    public quantity = 0,
    public price = 0,
    public description = "",
    public status: UnitStatus = new UnitStatus("unknown"), // Aqui está a instância padrão
    public projectPlanId = "",
    public priceHistory: PriceHistory[] = [],
    public block = "",
    public tipoUnidade = "",
    public complemento = "",
    public numeroOuLote = "",
    public endereco: Endereco = {
      rua: "",
      numero: "",
      bairro: "",
      cidade: "",
    }
  ) {}
}
